import * as PROJECT_TYPES from './projects'

export const PROJECT_SAVE_INTERVAL = 1000 // ms

export const SUPER_USERS = ['sonamkumari', 'zkorczyc', 'risharma', 'trehan', 'opawica', 'latapie', 'badajena']

export const PATHS = {
  BASE: '/',
  HOME: '/',
  PROJECT_LIST: '/projects',
  PROJECT_DETAILS: '/projects/',
  INSTALL: '/install',
  WEB_PROJECT: '/run/',
  WEB_MODULAR_PROJECT: '/web/',
  WEB_MODULAR_PROJECT_EDITOR: '/web/_edit/',
  SSR_PROJECT: '/ssr/',
  CALL_CENTER: '/cc/',
  CUSTOMER_EXPERIENCE: '/cx/',
  CUSTOMER_EXPERIENCE_V2: '/cx2/',
  JOURNEY_TRIGGER: '/jt/',
  SCREENS_TAB: '/screens',
  SCREEN_DETAILS: '/screens/',
  NAVIGATION_TAB: '/navigation',
  BRANDING_TAB: '/branding',
  INTEGRATIONS_TAB: '/integrations',
  TRIGGERS_TAB: '/triggers',
  PROFILE_VIEWER: '/profile-viewer',
  PRODUCTS: '/products',
  PRODUCT_DETAILS: '/products/',
  MODULES: '/modules',
  MODULE_CONFIGURATOR: '/modules/',
  USER_CONTEXT: '/userContext',
  DATA_ELEMENTS_TAB: '/data-elements',
  RULES_TAB: '/rules',
  ACCESS: '/access',
  DECISIONING_SURFACES: '/decisioning-surfaces',
  SETTINGS: '/settings',
  SHARE: '/share',
  INSIGHTS: '/insights',
}

export const CLIENT_PATHS = {
  web: PATHS.WEB_PROJECT,
  'web-modular': PATHS.WEB_MODULAR_PROJECT,
  'customer-hub': PATHS.WEB_MODULAR_PROJECT,
  'web-social': PATHS.WEB_MODULAR_PROJECT,
  'call-center': PATHS.CALL_CENTER,
  'customer-experience': PATHS.CUSTOMER_EXPERIENCE,
  'customer-experience-v2': PATHS.CUSTOMER_EXPERIENCE_V2,
  'journey-trigger': PATHS.JOURNEY_TRIGGER,
  ssr: PATHS.SSR_PROJECT,
}

export const MAX_FILE_SIZE = {
  image: 2 * 1000000, // in megabytes,
  video: 200 * 1000000, // in megabytes
}
export const FILE_STORAGE = {
  BASE_URL: 'https://demo-system-next.s3.eu-north-1.amazonaws.com/argon',
  SCREENS_FOLDER: 'screens',
}

export const FORMATS = {
  DATE: 'YYYY-MM-DD',
  TIMESTAMP: 'YYYY-MM-DD HH:mm:ss',
}

export const TRIGGERS_TYPES = {
  beacon: {
    label: 'Beacon',
    value: 'beacon',
    icon: 'gears',
    options: [
      {
        label: 'Set Location',
        value: 'setLocation',
      },
    ],
  },
}

export const EDITOR = {
  GRID_SIZE: 25,
  DEFAULT_POSITION: {
    left: 0,
    top: 0,
  },
}

export { PROJECT_TYPES }

export const LOCALES = [
  'ar-SA',
  'bg-BG',
  'bn-IN',
  'cs-CZ',
  'da-DK',
  'de-DE',
  'en-GB',
  'en-IN',
  'en-US',
  'es-419',
  'es-ES',
  'es-MX',
  'et-EE',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'he-IL',
  'hi-IN',
  'hr-HR',
  'hu-HU',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'lt-LT',
  'lv-LV',
  'nb-NO',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'sk-SK',
  'sl-SI',
  'sr-RS',
  'sv-SE',
  'tr-TR',
  'uk-UA',
  'zh-CN',
  'zh-TW',
]
